import { FormGroup } from '@angular/forms';
import { getControl, getGroup } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';

export const getCoopGaranziaFidiGroup = (form: FormGroup): FormGroup => getGroup(form, formPaths.schedaCoopFidi);

export const getCoopGaranziaFidiControl = (form: FormGroup, path: string) => getControl(form, `${formPaths.schedaCoopFidi}.${path}`);
